import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import Styles from './Styles.module.scss';
import imgCeSign from '../assets/images/ce.png';
import { Footer } from 'app/Footer';

export const About: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className={Styles.container}>
        <p className={Styles.headerAbout}>{t('About_Usage_Header')}</p>
        <p className={Styles.text}>{t('About_Usage_Text')}</p>

        <hr />

        <p className={Styles.headerAbout}>{t('About_Requirements_Header')}</p>
        <ul className={Styles.text}>
          <Trans i18nKey="About_Requirements_Text">
            <li>content</li>
          </Trans>
        </ul>
        <hr />

        <p className={Styles.headerAbout}>{t('About_Devices_Header')}</p>

        <p className={Styles.text}>
          <Trans i18nKey="About_Devices_Text">
            text
            <ul>
              <li>content</li>
            </ul>
          </Trans>
        </p>
        <hr />

        <p className={Styles.headerAbout}>{t('About_Declaration_Header')}</p>
        <p className={Styles.text}>{t('About_Declaration_Text')}</p>
        <img src={imgCeSign} alt="Notified body CE marking CE 0197" />
      </div>

      <div className="splitter appContainerBottomSplitter" />
      <Footer />
    </div>
  );
};
